import { render, staticRenderFns } from "./PianoTerapeuticoCliente.vue?vue&type=template&id=45f04a35&"
import script from "./PianoTerapeuticoCliente.vue?vue&type=script&lang=js&"
export * from "./PianoTerapeuticoCliente.vue?vue&type=script&lang=js&"
import style0 from "./PianoTerapeuticoCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports